// AJAX CART

//DOM ELEMENTS

// Add To Cart Form - used throughout website so will work for all.
const addToCartForm = document.querySelectorAll('#product-form');

// Add To Cart Form Upsells - used throughout website so will work for all.
const addonForm = document.querySelectorAll('#addon-form');

//Slide Cart Wrapper
const slideCartWrapper = document.querySelector('.slide-cart-wrapper');

addToCartForm.forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    document.getElementById('addToCartButton').textContent = "ADDING..";

    // Submit the form with AJAX
      await fetch("/cart/add", {
        method: "POST",
        body: new FormData(form),
      });

    //Update Cart Count Header
      updateHeaderCartCount();
      
    // Update Slide Cart
      updateSlideCart();

      updateShippingBar();

    // Open
      openSlideCart();

    // Rename Button
    document.getElementById('addToCartButton').textContent = "ADD TO BASKET";

  });
});

// Open Slide Cart
function openSlideCart() {
  slideCartWrapper.classList.add("slide-cart--active");
  document.body.style.overflowY = "hidden";
}

// Close Slide Cart
function closeSlideCart() {
  slideCartWrapper.classList.remove("slide-cart--active");
  document.body.style.overflowY = "scroll";
}

// Update Cart Count in Header
async function updateHeaderCartCount() {
  // Get New Cart Object
    const res = await fetch("/cart.json");
    const cart = await res.json();

  document.querySelectorAll(".header-cart-item-count").forEach(el => {
    el.textContent = cart.item_count;
  });
}

// Slide Cart Listeners
  async function slideCartListeners() {

    // Update Quantity Input
    document.querySelectorAll('.slide-cart-quantity button').forEach((button) => {
      button.addEventListener('click', async () => {

    // Get Line item Key
    const rootLineItem = button.closest("#slide-cart-item").getAttribute("slide-cart-line-item-key");

    // Get New Quantity to Check Inventory

    const currentQty = Number(button.parentElement.querySelector('input[name="updates[]"]').value);

    const isUp = button.classList.contains('quantity-plus');

    const newQty = isUp ? currentQty + 1 : currentQty - 1;
      
    // Update QTY with AJAX
      const res = await fetch('/cart/update.js', {
      method: "POST",
      headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [rootLineItem]: newQty } }),
    });

    // Update Slide Cart
      updateSlideCart();

    // Update Header Cart Count
      updateHeaderCartCount();

      updateShippingBar();

  });
    
  async function removeItem(key, quantity, item) {
    // Remove with AJAX
      const res = await fetch('/cart/update.js', {
        method: "POST",
        headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [key]: quantity } }),
    });

    const cart = await res.json();

      if (cart.items.length === 0) {
        closeSlideCart();
        updateSlideCart()
        updateHeaderCartCount();
        updateShippingBar();
      } else {
        updateHeaderCartCount();
        const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
        const totalPrice = formatMoney(cart.total_price, format);
        document.querySelector(".total-amount").textContent = totalPrice;
        item.remove();
        updateShippingBar();
      }
    }

        
// Remove Product
  document.querySelectorAll(".slide-cart-remove").forEach((remove) => {
    remove.addEventListener("click", (e) => {
      e.preventDefault();

      const item = remove.closest(".slide-cart-item");
      const key = item.getAttribute('slide-cart-line-item-key');
      removeItem(key, 0, item);

      });
      
    });

  });

  // Stop Inner Slide Cart closing cart
    document.querySelector(".slide-cart-inner-wrapper").addEventListener("click", (e) => {
      e.stopPropagation();
    });

  // Close Slide Cart
    document.querySelectorAll(".slide-cart-close, .slide-cart-wrapper").forEach((close) => {
      close.addEventListener("click", () => {
        closeSlideCart();
      });
    });

    updateShippingBar();

}

slideCartListeners();

// Open Slide Cart
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
      e.preventDefault();
      openSlideCart();
  })
})

// Update Slide Cart Inner Item HTML
  async function updateSlideCart() {
  const res = await fetch("/?section_id=template-slide-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newItems = html.querySelector(".slide-cart-wrapper").innerHTML;
  slideCartWrapper.innerHTML = newItems;
  slideCartListeners();
  updateShippingBar();
}

function formatPrice(amount) {
  const fixed = Number(amount).toFixed(2);
  return fixed.endsWith('.00') ? fixed.slice(0, -3) : fixed;
}

function updateShippingBar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const thresholdCentsMap = {
        USD: 7500,  // $100
        EUR: 10000,   // €75 example threshold
        GBP: 7500,   // £100 example threshold
        // Add other currencies and thresholds here
      };

      const currency = cart.currency || shopCurrency || 'USD';
      const currencySymbolMap = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        // Add others as needed 
      };

      const threshold = thresholdCentsMap[currency] || 10000;
      const subtotal = cart.total_price;
      const percent = Math.min(100, (subtotal / threshold) * 100);

      document.querySelector('.progress-bar').style.width = percent + '%';

      const message = document.querySelector('.shipping-bar-message');
      const currencySymbol = currencySymbolMap[currency] || '$';

      if (subtotal >= threshold) {
        message.textContent = `You've unlocked free shipping!`;
      } else {
        const rawRemaining = (threshold - subtotal) / 100;
        const remaining = formatPrice(rawRemaining);
        message.textContent = `Add ${currencySymbol}${remaining} more for free shipping!`;
      }
    });
}


// Add-On Form - used throughout website so will work for all.
addOn();

// Addon Form Submit (within slide out cart)
function addOn() {
  // Addon Form Submit (within slide out cart)
  
  addonForm.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
    
      form.querySelector('#addon-btn').textContent = "ADDING...";
    
      // Submit the form with AJAX
        await fetch("/cart/add", {
          method: "POST",
          body: new FormData(form),
        });
    
      // Get New Cart Object
        const res = await fetch("/cart.json");
        const cart = await res.json();

      //Update Cart Count Header
        updateHeaderCartCount();
      
      // Update Slide Cart
        updateSlideCart();

      // Rename Button
        form.querySelector('#addon-btn').textContent = "ADD TO CART";

      // Update Slide Cart
        openSlideCart();
      
    });
  });
};
